import classNames from 'classnames'
import { Icon } from 'components/misc'
import React, { useState, useRef, useEffect, useCallback } from 'react'
import { observer, inject } from 'mobx-react'
import { debounce } from 'lodash'

const ConversationSearch = ({ actions }) => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  const { setActionProfileSearchTerm } = actions?.chat
  const [ searchTerm, setSearchTerm ] = useState('');
  const timeoutRef = useRef(null)

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      clearTimeout(timeoutRef.current);
    };
  }, [])

  const handleClickOutside = event => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setOpen(false)
      setSearchTerm('')
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setActionProfileSearchTerm(''), 500)
    }
  }

  const handleOpen = () => {
    setOpen(prev => !prev)
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  }

  const handleSearchTermChange = event => {
    setSearchTerm(event.target.value)
    debouncedSetActionProfileSearchTerm(event.target.value)
  }

  const debouncedSetActionProfileSearchTerm = useCallback(
    debounce(value => {
      setActionProfileSearchTerm(value);
    }, 300),
    [setActionProfileSearchTerm]
  );

  return (
    <div className={classNames('search-input-wrapper', { open: open })} ref={containerRef}>
      <Icon iconName="search" className="chat-list-search-icon" onClick={handleOpen}/>
      <input
        ref={inputRef}
        className="conversation-search-input"
        type="text"
        value={searchTerm}
        onChange={handleSearchTermChange}
      />
    </div>
  )
}

export default inject('store', 'actions')(observer(ConversationSearch))
